import {createContext, useContext} from "react";

export const NewsContext = createContext(null)
export const useNews = () => useContext(NewsContext);